import * as React from "react";
import { Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import I18n from "i18next";

import { MzRadioGroup, MzRadio } from "@markaaz/ui/MzRadioControls";
import MzButton from "@markaaz/ui/MzButton";
import MzInput from "@markaaz/ui/MzInputControls";
import MzAutocomplete from "@markaaz/ui/MzAutocomplete";
import { MzDialog, MzDialogTitle, MzDialogContent, MzDialogActions } from "@markaaz/ui/MzDialogControls";

const sx = {
  paper: {
    borderRadius: "20px",
    width: "520px"
  },

  content: {},

  selector: {
    width: "325px",
    marginTop: "50px"
  },

  buttonWrap: {
    justifyContent: "center"
  }
};

export default function AddPortfolio({ open, portfolios, handleClose, handleSubmit }) {
  const [portSelection, setPortSelection] = React.useState(null);
  const [portfolioName, setPortfolioName] = React.useState(null);
  const [selectedPortfolioId, setSelectedPortfolioId] = React.useState(null);

  React.useEffect(() => {
    reset();
  }, [open]);

  function onClose() {
    handleClose();
  }

  function handleChange(_, value) {
    setPortSelection(value);
    setSelectedPortfolioId(null);
    setPortfolioName(null);
  }

  function handleCta() {
    handleSubmit(portfolioName, selectedPortfolioId);
  }

  function handlePorfolioChange(_, value) {
    setSelectedPortfolioId(value.id);
  }

  function reset() {
    setPortSelection(null);
    setPortfolioName(null);
    setSelectedPortfolioId(null);
  }

  return (
    <MzDialog sx={sx.dialog} PaperProps={{ sx: sx.paper }} open={open} onClose={onClose}>
      <MzDialogTitle>Do you wish to append the file to an existing portfolio?</MzDialogTitle>
      <MzDialogContent sx={sx.content}>
        <FormControl>
          <MzRadioGroup row name="row-radio-buttons-group" value={portSelection} onChange={handleChange}>
            <MzRadio value="yes" label="Yes" typographyVariant="body2" />
            <MzRadio value="no" label="No" typographyVariant="body2" />
          </MzRadioGroup>
        </FormControl>

        <Box sx={sx.selector} style={{ display: portSelection ? "block" : "none" }}>
          <Box style={{ display: portSelection === "yes" ? "block" : "none" }}>
            <MzAutocomplete
              label="Choose portfolio"
              placeholder="Select"
              options={portfolios}
              onChange={handlePorfolioChange}
            />
          </Box>
          <Box style={{ display: portSelection === "no" ? "block" : "none" }}>
            <MzInput
              label="Enter portfolio name"
              fullWidth
              variant="outlined"
              onChange={(e) => {
                setPortfolioName(e.target.value);
              }}
              placeholder="Portfolio name"
            />
          </Box>
        </Box>
      </MzDialogContent>
      <MzDialogActions sx={!portSelection && sx.buttonWrap}>
        <MzButton variant="outlined" color="secondary" size="large" onClick={handleClose}>
          {I18n.t("common.cancel")}
        </MzButton>
        {portSelection && (
          <MzButton variant="contained" size="large" onClick={handleCta}>
            {I18n.t("common.submit")}
          </MzButton>
        )}
      </MzDialogActions>
    </MzDialog>
  );
}
